import { API_JWT_BASE_URL } from '../http'

export const GET_CUSTOMIZATION_PROFILES_API = `${API_JWT_BASE_URL}/CustomizationProfiles`
export const GET_CUSTOMIZATION_PROFILES_SUMMARY_API = `${API_JWT_BASE_URL}/CustomizationProfiles/summary`

export const CREATE_FIELDS_API = `${API_JWT_BASE_URL}/customizationprofiles/createField`
export const UPDATE_FIELD_API = `${API_JWT_BASE_URL}/customizationprofiles/updateField`
export const CREATE_PROFILES_API = `${API_JWT_BASE_URL}/customizationprofiles/createProfile`
export const CREATE_MAPPINGS_API = `${API_JWT_BASE_URL}/customizationprofiles/createMapping`
export const UPDATE_MAPPING_API = `${API_JWT_BASE_URL}/customizationprofiles/updateMapping`
export const GET_SUMMARY_FIELDS_API = `${API_JWT_BASE_URL}/customizationprofiles/searchsummaryField`
export const GET_SUMMARY_PROFILES_API = `${API_JWT_BASE_URL}/customizationprofiles/searchsummaryProfile`
export const GET_SUMMARY_MAPPINGS_API = `${API_JWT_BASE_URL}/customizationprofiles/searchsummaryMapping`
export const OBSOLETE_SUMMARY_FIELDS_API = `${API_JWT_BASE_URL}/customizationprofiles/summaryField/obsolete`
export const OBSOLETE_SUMMARY_PROFILES_API = `${API_JWT_BASE_URL}/customizationprofiles/summaryProfile/obsolete`
export const OBSOLETE_SUMMARY_MAPPINGS_API = `${API_JWT_BASE_URL}/customizationprofiles/summaryMapping/obsolete`
export const EXPORT_CUSTOMIZATION_SUMMARY = `${API_JWT_BASE_URL}/customizationprofiles/summaryExport`
export const IMPORT_CUSTOMIZATION_SUMMARY = `${API_JWT_BASE_URL}/customizationprofiles/summaryimport`

export const CUSTOMIZATION_PROFILES_QUERY_KEYS = {
  GET_CUSTOMIZATION_PROFILES: 'GET_CUSTOMIZATION_PROFILES',
  GET_CUSTOMIZATION_PROFILES_SUMMARY: 'GET_CUSTOMIZATION_PROFILES_SUMMARY',
  CREATE_FIELDS: 'CREATE_FIELDS',
  CREATE_PROFILES: 'CREATE_PROFILES',
  CREATE_MAPPINGS: 'CREATE_MAPPINGS',
  GET_SUMMARY_FIELDS: 'GET_SUMMARY_FIELDS',
  GET_SUMMARY_PROFILES: 'GET_SUMMARY_PROFILES',
  GET_SUMMARY_MAPPINGS: 'GET_SUMMARY_MAPPINGS',
  OBSOLETE_SUMMARY_FIELDS: 'OBSOLETE_SUMMARY_FIELDS',
  OBSOLETE_SUMMARY_PROFILES: 'OBSOLETE_SUMMARY_PROFILES',
  OBSOLETE_SUMMARY_MAPPINGS: 'OBSOLETE_SUMMARY_MAPPINGS',
  EXPORT_CUSTOMIZATION_SUMMARY_API: 'EXPORT_CUSTOMIZATION_SUMMARY_API',
  IMPORT_CUSTOMIZATION_SUMMARY_API: 'IMPORT_CUSTOMIZATION_SUMMARY_API',
  UPDATE_FIELDS: 'UPDATE_FIELDS',
  UPDATE_MAPPING: 'UPDATE_MAPPING'
}
